/**
 * S3 bucket for the flyers activity (m-flyers, 2 published programs). The aws-sdk client is
 * NOT built here any more: state is part of the root store, so constructing it at import time
 * put aws-sdk (~107 KB gzip) into the entry bundle every visitor downloads (load-speed work
 * 2026-09-14). actions.ts creates the client on first upload instead.
 *
 * SECURITY: the VITE_S3_* access key still ships to the browser inside the lazy chunk. The key
 * must be rotated and the upload moved behind a server-issued presigned URL (see actions.ts).
 */
const state = {
  BUCKET: import.meta.env.VITE_S3_BUCKET_NAME
};
export default state;
